<template>
  <f7-page>
    <template #fixed>
      <TheNavbar
        :nav-title="reportTitle"
        class="secondary-navbar"
        back-btn-enable
      />
    </template>

    <VuePdfApp :pdf="pdf" />
  </f7-page>
</template>

<script setup>
// @ts-check
import TheNavbar from '@/components/TheNavbar.vue';
import VuePdfApp from 'vue3-pdf-app';
import 'vue3-pdf-app/dist/icons/main.css';

defineProps({
  pdf: {
    type: [String, ArrayBuffer],
    default: null,
  },
  reportTitle: {
    type: String,
    default: 'Informe',
  },
});
</script>
